import {
  FormControl,
  FormLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import { AddButton } from "ui-components/IconButton";
import { CancelButton } from "ui-components/IconButton";
import { DeleteButton } from "ui-components/IconButton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    border: "1px solid #c7c5c5",

    //borderBottom:"1px solid rgba(0,0,0,.2)"
  },
  [`&.${tableCellClasses.body}`]: {
    border: "1px solid #c7c5c5",
    fontSize: 16,
    padding: ".2rem 1rem",
    //borderBottom:"1px solid c7cfde"
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

const rowStatusLabel = {
  Open: "lightcyan",
  Cancel: "lightyellow",
  Recv: "#bff8d9",
  Received:"#bff8d9",
  ASN_CO_RECV: "lavender",
  NotEnoughStock: "bisque",
  BackOrder:"bisque"
};

function BasicTable2({
  statusLabel = null,
  columns,
  rows,
  onDelete = null,
  onCancel = null,
  onAdd = null,
  onRowClick = null,
  mode = "ADD",
  caption = null,
}) {
  const [selected, setSelected] = useState(-1);
  const label = () => {
    if (statusLabel === null) {
      return <StatusLabel />;
    } else if (statusLabel === "SO") {
      return <SOStatusLabel />;
    }else if (statusLabel === "LM"){
      return <LMStatusLabel/>
    }
  };
  return (
    <>
      {label()}
      <TableContainer component={Paper} sx={{ border: "1px solid rgba(0,0,0,.2)", boxShadow: 0 }}>
        <Table stickyHeader>
          <caption style={{ fontWeight: "bold" }}>{caption ? caption : "Total Quantity"}</caption>
          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {columns.map((column, index) => {
                let sx = { minWidth: 150 };
                if (column.field === "actions") {
                  sx = { ...sx, position: "sticky", left: 0, minWidth: 80, zIndex: "21!important" };
                }
                if (column.field === "lineNo") {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: 80,
                    minWidth: 100,
                    zIndex: "21!important",
                  };
                }
                if (column.field === "extPOLineNo") {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: 150,
                    zIndex: "21!important",
                  };
                }
                if (column.field === "returnCode") {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: 150,
                    zIndex: "21!important",
                  };
                }
                if (column.field === "orderNumber") {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: 150,
                    zIndex: "21!important",
                  };
                }
                if (column.field === "skuCode") {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: 200,
                    zIndex: "21!important",
                  };
                }
                if (column.left !== undefined) {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: column.width,
                    zIndex: "21!important",
                  };
                }

                if (column.width !== undefined) {
                  sx = { ...sx, minWidth: column.width };
                }

                // if(column.left!==undefined){
                //   sx={position:"sticky",left:column.left,zIndex:"21!important"}
                //   if(column.border){
                //     sx={...sx,borderRight:"1px solid rgba(0,0,0,.2)"}
                //   }
                // }
                return (
                  <StyledTableCell key={index} sx={sx}>
                    {column.headerName}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, rowIndex) => {
              const rowStatus = row["status"];
              const isSelected = selected === rowIndex ? true : false;
              let background;
              if (mode === "ADD" || Boolean(row["newItem"]) === true) {
                background = isSelected ? "#f6d6ea" : "white";
              } else {
                background = isSelected ? "#f6d6ea" : rowStatusLabel[rowStatus];
              }
              return (
                <TableRow sx={{ background }} key={rowIndex} selected={isSelected}>
                  {columns.map((column, index) => {
                    if (column.field === "actions") {
                      let sxActions = {
                        display: "flex",
                        background,
                        borderRight: "1px solid rgba(224,224,224,1)",
                        borderBottom: "1px solid rgba(224,224,224,1)",
                        position: "sticky",
                        left: 0,
                        zIndex: "11!important",
                      };
                      return (
                        <StyledTableCell sx={sxActions}>
                          <>
                            {column.renderActions.map((x) => {
                              const status =
                                row["status"] !== "Open" && row["status"] !== "NotEnoughStock" && row["status"] !== "BackOrder"
                                  ? true
                                  : false;
                              if (x === "Delete") {
                                return (
                                  <DeleteButton title="delete" onClick={() => onDelete(row)} />
                                );
                              } else if (x === "Cancel") {
                                const renderCell = row["newItem"] ? (
                                  <DeleteButton title="delete" onClick={() => onDelete(row)} />
                                ) : (
                                  <CancelButton
                                    title="cancel"
                                    onClick={() => onCancel(row)}
                                    disabled={status}
                                  />
                                );
                                return renderCell;
                              } else if (x === "Add") {
                                const renderCell = !status ? (
                                  <AddButton title="add" onClick={() => onAdd(row)} />
                                ) : (
                                  <></>
                                );
                                return renderCell;
                              }
                            })}
                          </>
                        </StyledTableCell>
                      );
                    }
                    let cellValue = row[column.field] ?? "";
                    if (column.valuesGetter) {
                      cellValue = column.valuesGetter(cellValue);
                    }
                    let sx = {
                      padding: "8px 16px",
                      background,
                      borderBottom: "1px solid rgba(224,224,224,1)",
                      borderRight: "1px solid rgba(224,224,224,1)",
                    };
                    if (column.field === "lineNo") {
                      sx = { ...sx, position: "sticky", left: 80, minWidth: 100, zIndex: 2 };
                    }
                    if (column.left) {
                      sx = { ...sx, position: "sticky", left: column.left, zIndex: 2 };
                      if (column.border) {
                        sx = { ...sx, borderRight: "1px solid rgba(0,0,0,.2)" };
                      }
                    }
                    return (
                      <StyledTableCell
                        onClick={() => {
                          if (onRowClick === null) return;
                          const valid = onRowClick(row);
                          console.log(valid)
                          if (valid) setSelected(rowIndex);
                          // setSelected(rowIndex);
                          // onRowClick(row);
                        }}
                        sx={sx}
                        key={index}
                        align={column.align ?? "left"}
                      >
                        {cellValue}
                      </StyledTableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

const StatusLabel = () => {
  return (
    <MDBox mt={2}>
      <MDTypography color="info" variant="h5" mr="2rem">
        Datagrid Display
      </MDTypography>
      <MDBox sx={{ padding: "8px 0" }} display="flex" alignItems="center">
        <MDTypography color="info" variant="h5" mr="1rem">
          Row Status :
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#bdf9f9",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Open
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#fdfdc1",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Cancelled
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#d9d9ff",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          ASN / CO / RECV
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#bff8d9",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Received
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "lightpink",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Selected
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

const SOStatusLabel = () => {
  return (
    <MDBox mt={2}>
      <MDTypography color="info" variant="h5" mr="2rem">
        Datagrid Display
      </MDTypography>
      <MDBox sx={{ padding: "8px 0" }} display="flex" alignItems="center">
        <MDTypography color="info" variant="h5" mr="1rem">
          Row Status :
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#bdf9f9",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Open
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "bisque",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          NotEnoughStock
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#fdfdc1",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Cancelled
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "lightpink",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Selected
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

const LMStatusLabel = () => {
  return (
    <MDBox mt={2}>
      <MDTypography color="info" variant="h5" mr="2rem">
        Datagrid Display
      </MDTypography>
      <MDBox sx={{ padding: "8px 0" }} display="flex" alignItems="center">
        <MDTypography color="info" variant="h5" mr="1rem">
          Row Status :
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#bdf9f9",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Open
        </MDTypography>
        <span
          style={{
            width: "1rem",
            height: "1rem",
            border: "1px solid black",
            background: "#fdfdc1",
          }}
        ></span>
        <MDTypography ml={1} variant="h6" mr="2rem">
          Cancelled
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

const Fieldset = ({ children, label }) => (
  <FormControl
    sx={{
      padding: "0 15px",
      marginBottom: "12px",
      borderRadius: ".375rem",
      border: "2px solid #d6d9f6",
    }}
    component="fieldset"
    // fullWidth
  >
    <FormLabel
      sx={{ padding: "0 10px 8px 8px", color: "#1A73E7", fontWeight: "bold" }}
      component="legend"
    >
      {label}
    </FormLabel>
    {children}
  </FormControl>
);

export default BasicTable2;
